import eventBus from "../controls/event-bus";

export const hideLoadingSpinners = () => {
  const spinnerDivs = document.querySelectorAll(
    ".ad-preview-loading-preview-container:not(.d-none)"
  );

  spinnerDivs.forEach(spinnerDiv => {
    spinnerDiv.classList.add("d-none");
  });
};

export const showLoadingSpinners = () => {
  hideLoadingSpinners();

  const spinnerDivs = document.querySelectorAll(".ad-preview-loading-preview-container.d-none");
  spinnerDivs.forEach(spinnerDiv => {
    spinnerDiv.classList.remove("d-none");
  });
};

export const refreshIframe = selector => {
  const activeIframes = document.querySelectorAll(`${selector}.preview-on-top`);
  activeIframes.forEach(activeIframe => {
    const parent = activeIframe.parentNode;
    showLoadingSpinners();
    let inactiveIframe = parent.querySelector(`${selector}.preview-on-bottom`);
    if (!inactiveIframe) {
      inactiveIframe = activeIframe.cloneNode(true);
      inactiveIframe.classList.remove("preview-on-top");
      inactiveIframe.classList.add("preview-on-bottom");
      parent.insertBefore(inactiveIframe, activeIframe.nextSibling);
    } else {
      inactiveIframe.src = inactiveIframe.src;
    }
    inactiveIframe.onload = () => {
      hideLoadingSpinners();
      inactiveIframe.classList.remove("preview-on-bottom");
      inactiveIframe.classList.add("preview-on-top");
      activeIframe.classList.remove("preview-on-top");
      activeIframe.classList.add("preview-on-bottom");
      return true;
    };
  });
};

export const updateControl = async (
  request,
  label,
  errorSetter,
  updatePreview = () => refreshIframe(".ad-preview-iframe"),
  redirectUrl = null
) => {
  showLoadingSpinners();
  try {
    const response = await request();
    if (response.status < 300) {
      errorSetter(null);
    }
    if (response.data.refreshCreative) {
      if (
        response.data.creatomateSource &&
        Object.keys(response.data.creatomateSource).length > 0
      ) {
        eventBus.emit("creatomateSourceUpdated", {
          source: response.data.creatomateSource,
          refreshPreview: response.data.refreshCreatomate
        });
      } else {
        updatePreview();
      }
    } else {
      hideLoadingSpinners();
    }
    if (response.data.refreshPage) {
      showLoadingSpinners();
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        window.location.reload();
      }
    }
  } catch (err) {
    hideLoadingSpinners();
    const message = `There was a problem updating ${label}: ${err.response?.data?.errors || err}`;
    errorSetter(message);
    throw new Error(message);
  }
};

export const findInitialValueProvider = inputs => {
  return inputs.find(input => input.initialValueProvider);
};

export const findInputByKey = (inputs, key) => {
  return inputs.find(input => input.key === key);
};

export const hasError = inputs => {
  return !!inputs.find(input => input.errorMessage);
};

export const errorMessageFromInputs = inputs => {
  const errorMessages = inputs
    .map(input => input.errorMessage)
    .filter(errorMessage => errorMessage);
  return [...new Set(errorMessages)].join(", ");
};

export const getImportMode = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("import_source") === "canva" ? "canva" : "upload";
};

export const getUiErrors = () => {
  const errorElements = document.querySelectorAll(".input-error-message.visible");
  return Array.from(errorElements)
    .map(element => element.textContent)
    .filter(text => text);
};
